import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Language";
import "./Pricing.css";

const packages = [
  {
    id: "starter",
    name: "Starter",
    note: "Ein kompakter Einstieg für euren Ort.",
    price: 6700,
    codes: 5,
  },
  {
    id: "advanced",
    name: "Advanced",
    note: "Mehr Inhalte. Mehr Möglichkeiten vor Ort.",
    price: 9600,
    codes: 10,
  },
  {
    id: "individual",
    name: "Individual",
    note: "Ein Konzept, das sich nach eurem Ort richtet.",
    features: ["Individueller Umfang", "Persönliche Beratung"],
  },
];

function Pricing() {
  const { language, t } = useLanguage();
  return (
    <section
      id="products"
      className="pricing-section page-width"
      aria-labelledby="products-title"
    >
      <div className="pricing-introduction">
        <h2 id="products-title" tabIndex={-1}>
          {t("Passend für euren Bewegungsraum.")}
        </h2>
        <p className="page-description">
          {t(
            "Vom ersten QR-Code bis zum individuellen Konzept: Findet den passenden Einstieg für euren Ort.",
          )}
        </p>
      </div>
      <div className="pricing-grid">
        {packages.map((pack) => (
          <article
            className={`pricing-package package-${pack.id}`}
            key={pack.id}
            aria-labelledby={`package-${pack.id}`}
          >
            <div className="package-name">
              <h3 id={`package-${pack.id}`}>{pack.name}</h3>
              <p>{t(pack.note)}</p>
            </div>
            {pack.codes ? (
              <div className="package-scope">
                <p className="package-quantity">
                  {t(`${pack.codes} individuelle QR-Codes`)}
                </p>
                <p className="package-service">
                  {t("2 Jahre Service inklusive")}*
                </p>
              </div>
            ) : (
              <ul>
                {pack.features.map((feature) => (
                  <li key={feature}>{t(feature)}</li>
                ))}
              </ul>
            )}
            <div className="package-enquiry">
              <p className="package-price">
                {pack.price
                  ? new Intl.NumberFormat(
                      language === "de" ? "de-DE" : "en-IE",
                      {
                        style: "currency",
                        currency: "EUR",
                      },
                    ).format(pack.price)
                  : t("Auf Anfrage")}
              </p>
              <Link
                to={`/?p=${pack.id}#contact`}
                className={`action package-action${pack.id === "advanced" ? " package-action-light" : ""}`}
              >
                {t(pack.price ? "Paket anfragen" : "Projekt anfragen")}
              </Link>
            </div>
          </article>
        ))}
        <p className="pricing-footnote">
          *{" "}
          {t(
            "Danach 820,00 € pro Jahr. Preise inklusive gesetzlich gültiger Mehrwertsteuer.",
          )}
        </p>
      </div>
    </section>
  );
}
export default Pricing;
